// Export all svgs documented at https://shopify.dev/docs/api/liquid/filters/placeholder_svg_tag
import product1 from './product-1.svg';
import product2 from './product-2.svg';
import product3 from './product-3.svg';
import product4 from './product-4.svg';
import product5 from './product-5.svg';
import product6 from './product-6.svg';
import collection1 from './collection-1.svg';
import collection2 from './collection-2.svg';
import collection3 from './collection-3.svg';
import collection4 from './collection-4.svg';
import collection5 from './collection-5.svg';
import collection6 from './collection-6.svg';
import lifestyle1 from './lifestyle-1.svg';
import lifestyle2 from './lifestyle-2.svg';
import image from './image.svg';
import productApparel1 from './product-apparel-1.svg';
import productApparel2 from './product-apparel-2.svg';
import productApparel3 from './product-apparel-3.svg';
import productApparel4 from './product-apparel-4.svg';
import collectionApparel1 from './collection-apparel-1.svg';
import collectionApparel2 from './collection-apparel-2.svg';
import collectionApparel3 from './collection-apparel-3.svg';
import collectionApparel4 from './collection-apparel-4.svg';
import heroApparel1 from './hero-apparel-1.svg';
import heroApparel2 from './hero-apparel-2.svg';
import heroApparel3 from './hero-apparel-3.svg';
import blogApparel1 from './blog-apparel-1.svg';
import blogApparel2 from './blog-apparel-2.svg';
import blogApparel3 from './blog-apparel-3.svg';
import detailedApparel1 from './detailed-apparel-1.svg';

const svgs = {
  image,
  'product-1': product1,
  'product-2': product2,
  'product-3': product3,
  'product-4': product4,
  'product-5': product5,
  'product-6': product6,
  'collection-1': collection1,
  'collection-2': collection2,
  'collection-3': collection3,
  'collection-4': collection4,
  'collection-5': collection5,
  'collection-6': collection6,
  'lifestyle-1': lifestyle1,
  'lifestyle-2': lifestyle2,
  'product-apparel-1': productApparel1,
  'product-apparel-2': productApparel2,
  'product-apparel-3': productApparel3,
  'product-apparel-4': productApparel4,
  'collection-apparel-1': collectionApparel1,
  'collection-apparel-2': collectionApparel2,
  'collection-apparel-3': collectionApparel3,
  'collection-apparel-4': collectionApparel4,
  'hero-apparel-1': heroApparel1,
  'hero-apparel-2': heroApparel2,
  'hero-apparel-3': heroApparel3,
  'blog-apparel-1': blogApparel1,
  'blog-apparel-2': blogApparel2,
  'blog-apparel-3': blogApparel3,
  'detailed-apparel-1': detailedApparel1,
};

export default svgs;
